// extracted by mini-css-extract-plugin
module.exports = {"arrows":"Arrows_arrows__62lBj","arrow":"Arrows_arrow__NpgJh"};